import styled, { css } from 'vue-styled-components';

const InputNumber = styled.input`
padding: 5px 12px;
color: #373E44;
width: 72px;
height: 32px;
border: 1px solid #CED4DA;
border-radius: 4px;
outline: unset;
text-align: right;

/* &:focus, &:active, &:focus-visible {
    border: unset;
    outline: unset;

} */
/* Chrome, Safari, Edge, Opera */

&::-webkit-outer-spin-button,
&::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
&[type=number] {
  -moz-appearance: textfield;
}
`
const Slider = styled.input`
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  border-radius: 15px;
  background: #DFE2E6;
  outline: none;
  -webkit-transition: .2s;
  transition: opacity .2s;

&::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background: #FFFFFF;
  cursor: pointer;
  border: 1px solid #DFE2E6;
  border-radius: 50%;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
  z-index: 1;
  position: relative;
}

&::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: #FFFFFF;
    cursor: pointer;
    border: 1px solid #DFE2E6;
    border-radius: 50%;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
    z-index: 1;
    position: relative;
}
`
const RangeFill = styled.span`
    position: absolute;
    left: 0;
    height: 10px;
    border-radius: 15px;
    background-color: var(--primary);
    pointer-events: none;
    top: calc(34%);
    max-width: 100%;
    
`
const InputNumberUnit = (unit) => {
  return css`&::after {
    content: '${unit}';
    position: absolute;
    pointer-events: none;
    width: fit-content;
    height: 10px;
    z-index: 10;
    right: 5px;
    top: 9px;
    font-size: 12px;
    color: #A5A5A5;
    margin-left: 5px;
  }`
}

const InputNumberWrapperUnitProps = { unit: String }

const InputNumberWrapper = styled('div', InputNumberWrapperUnitProps)`
position: relative;
width: 72px;
height: 32px;
${props => InputNumberUnit(props.unit)}

`
export {
  InputNumber,
  Slider,
  RangeFill,
  InputNumberWrapper,

}